import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faLinkedin, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const icons = {
  email: faEnvelope,
  linkedin: faLinkedin,
  twitter: faTwitter,
  facebook: faFacebook,
};

interface Props {
  service: keyof typeof icons
  url: string | null
  color?: string
}

export default (props: Props) => !props.url ? null :
  <div className="ph2 f4">
    <a 
      target="_blank" rel="noopener noreferrer"
      className={ `link dim ${ props.color || 'white' }` } href={ props.url } title={ props.service }>
        <FontAwesomeIcon icon={ icons[props.service] } />
    </a>
  </div>;

